module.exports = __webpack_public_path__ + "static/media/ES.e6a28e06.svg";